import React, { Component } from "react";
import $ from "jquery";
import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import Portfolio from "./Components/Portfolio";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      foo: "bar",
      resumeData: {},
    };
  }

  getResumeData() {
    $.ajax({
      url: "/resumeData.json",
      dataType: "json",
      cache: false,
      success: function (data) {
        this.setState({ resumeData: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.log(err);
        alert(err);
      },
    });
  }

  componentDidMount() {
    this.getResumeData();
    const script = document.createElement("script");

    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;

    document.body.appendChild(script);
  }

  render() {
    return (
      <div className="App">
        <Header data={this.state.resumeData.main} />
        <About data={this.state.resumeData.main} />
        <Resume data={this.state.resumeData.resume} />
        <Portfolio data={this.state.resumeData.portfolio} />
        <section id="blog">
          <ul>
            <li>
              <blockquote class="twitter-tweet">
                <p lang="en" dir="ltr">
                  Which framework is better?
                </p>
                &mdash; Bob (@Bob43360942){" "}
                <a href="https://twitter.com/Bob43360942/status/1335479333557702657?ref_src=twsrc%5Etfw">
                  December 6, 2020
                </a>
              </blockquote>
            </li>
            <li>
              <blockquote class="twitter-tweet">
                <p lang="en" dir="ltr">
                  I&#39;m gonna be playing{" "}
                  <a href="https://twitter.com/britgo?ref_src=twsrc%5Etfw">
                    @britgo
                  </a>{" "}
                  few weeks later!{" "}
                  <a href="https://t.co/UYj34M2xR8">
                    pic.twitter.com/UYj34M2xR8
                  </a>
                </p>
                &mdash; Bob (@Bob43360942){" "}
                <a href="https://twitter.com/Bob43360942/status/1337943181208391680?ref_src=twsrc%5Etfw">
                  December 13, 2020
                </a>
              </blockquote>
            </li>
          </ul>
        </section>
        <Contact data={this.state.resumeData.main} />
        <Footer data={this.state.resumeData.main} />
      </div>
    );
  }
}

export default App;
